// src/pages/MPFlow/components/EdyMascot.jsx
import { useEffect } from 'react';

const MESSAGES = {
  perfil:    'Olá! Sou Eddy. Vou te ajudar a criar anúncios que convertem. Conta pra mim sobre seu negócio!',
  criacao:   'Agora a IA entra em ação! Vou criar um copy personalizado para o seu público.',
  refino:    'Quase lá! Vamos ajustar e turbinar o seu criativo. Cada detalhe importa!',
  turbinar:  'Hora de colocar combustível! Escolha seu plano e ative sua campanha.',
  vendas:    'Sua campanha está ao vivo! Acompanhe cada resultado em tempo real.',
  loading:   'Processando com IA... aguarde um momento!',
};

const PHASE_MOOD = {
  perfil:   'think',
  criacao:  'think',
  refino:   'think',
  turbinar: 'rocket',
  vendas:   'celebrate',
  loading:  'think',
};

export default function EdyMascot({ phase = 'perfil', custom }) {
  const msg  = custom || MESSAGES[phase] || MESSAGES.perfil;
  const mood = PHASE_MOOD[phase] || 'default';

  useEffect(() => {
    window.dispatchEvent(new CustomEvent('edy-mood',    { detail: mood }));
    window.dispatchEvent(new CustomEvent('edy-message', { detail: msg  }));
  }, [mood, msg]);

  return null; // A fala aparece no painel direito, acima do Eddy
}
